import styles from '../../styles/admin/StudyContent.module.scss'
import ImageDropzone from './ImageDropzone'
import FractionQuestionInput from './FractionQuestionInput'

const ExplanationSection = ({
  explanation,
  onExplanationChange,
  explanationImageFile,
  onExplanationImageChange,
  existingImageUrl,
  onExistingImageRemove,
  placeholder = 'Write the explanation step by step.\n\nExample:\nStep 1: ...\nStep 2: ...',
  minRows = 12,
  showImage = true,
  className,
  label = 'Explanation',
}) => {
  return (
    <div className={styles.explanationSectionContainer}>
      <div className={styles.explanationSectionWrapper}>
        <div className={styles.explanationSectionHeader}>
          <FractionQuestionInput
            value={explanation}
            onChange={onExplanationChange}
            placeholder={placeholder}
            label={label}
          />
        </div>

        {showImage && (
          <div className={styles.explanationImageSection}>
            <ImageDropzone
              imageFile={explanationImageFile}
              onImageChange={onExplanationImageChange}
              existingImageUrl={existingImageUrl}
              iconSize={32}
              className={styles.imageDropzone}
              placeholderText="Drag & Drop or Click to Upload"
              showLabel={true}
              label="Explanation IMG"
              onExistingImageRemove={onExistingImageRemove}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ExplanationSection
